import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Button,
  makeStyles,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Link, useLocation } from 'react-router-dom';
import CompanyLogo from '../../assets/icons/CompanyLogo';
import { useState } from 'react';
import { IS_DEVELOPMENT } from '../../utils/constant';

const useStyles = makeStyles(theme => ({
  appBar: {
    backgroundColor: '#2e2e2e',
    boxShadow: 'none',
  },
  logo: {
    marginRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  nav: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
  },
  navLink: {
    color: '#fff',
    textTransform: 'none',
    fontWeight: 500,
    marginRight: theme.spacing(2),
    '&.active': {
      borderBottom: '2px solid #fff',
    },
    '&:hover': {
      background: 'rgba(255,255,255,0.08)',
    },
  },
  moreButton: {
    color: '#fff',
    marginLeft: theme.spacing(1),
  },
}));

const NAV_ITEMS = [
  { label: 'Reference Docs', to: '/prism/reference-docs' },
  { label: 'Change Logs', to: '/prism/change-logs' },
  { label: 'How to Docs', to: '/prism/how-to-docs' },
  ...(IS_DEVELOPMENT ? [{ label: 'Forum', to: '/prism/forum' }] : []),
];

const NavLinks: React.FC<{
  location: ReturnType<typeof useLocation>;
  classes: ReturnType<typeof useStyles>;
}> = ({ location, classes }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    {NAV_ITEMS.map(item => (
      <Button
        key={item.to}
        component={Link}
        to={item.to}
        className={
          location.pathname.startsWith(item.to)
            ? `${classes.navLink} active`
            : classes.navLink
        }
        disableRipple
        disableElevation
      >
        {item.label}
      </Button>
    ))}
  </div>
);

const Header: React.FC = () => {
  const classes = useStyles();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const showNavMenu = location.pathname.startsWith('/prism/');

  return (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar style={{ minHeight: 64, paddingLeft: 16, paddingRight: 16 }}>
        <Link to="/dashboard" className={classes.logo} aria-label="Home">
          <CompanyLogo className="h-10 w-10 mr-2" />
          <span>Property Management Technology Developer Portal</span>
        </Link>
        <nav className={classes.nav} aria-label="Main navigation">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {showNavMenu && <NavLinks location={location} classes={classes} />}
          </div>
        </nav>
        <IconButton
          edge="end"
          className={classes.moreButton}
          aria-label="more"
          aria-controls="header-menu"
          aria-haspopup="true"
          onClick={handleMenuOpen}
          style={{ display: IS_DEVELOPMENT ? 'block' : 'none' }}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="header-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem component={Link} to="/settings" onClick={handleMenuClose}>
            Settings
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
